import { render, staticRenderFns } from "./BaseTextareaInput.vue?vue&type=template&id=1b47bd6e&scoped=true"
import script from "./BaseTextareaInput.vue?vue&type=script&lang=js"
export * from "./BaseTextareaInput.vue?vue&type=script&lang=js"
import style0 from "./BaseTextareaInput.vue?vue&type=style&index=0&id=1b47bd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47bd6e",
  null
  
)

export default component.exports